import { COMPANY_ID, INV_TOKEN, RESET_PASS_TOKEN } from '../constants/auth.constants';

export const getSearchParam = (param: typeof COMPANY_ID | typeof INV_TOKEN | typeof RESET_PASS_TOKEN) => {
  return (
    new URLSearchParams(new URL(window.location.href).search).get(param) || ''
  );
};
